<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let productIdToEnsureUniqueSelectors: number;
  export let currentPickupLocation: { id: number; name: string };
  export let justify: string = "end";
  export let onDeliveryClick: () => void;
  export let onPickupClick: () => void;
  export let onChangePickupLocation: () => void;

  $: deliveryIsSelected = currentPickupLocation.id == null;
  $: pickupIsSelected = !deliveryIsSelected;
  $: pickupLocationName = currentPickupLocation.name || "Pickup Location";

</script>

<div
  class="fizz-stack-12 fizz-flex-row-8 fizz-justify-{justify}"
  data-testid="delivery-or-pickup-toggle"
>
  <label
    class="fizz-flex-row-8 fizz-inline-16"
    for="in-store-pickup-{productIdToEnsureUniqueSelectors}"
  >
    <input
      type="radio"
      id="in-store-pickup-{productIdToEnsureUniqueSelectors}"
      class="fizz-radio-button"
      on:click|preventDefault={onPickupClick}
      checked={pickupIsSelected}
    />
    <span class="">In store pickup</span>
  </label>
  <label class="fizz-flex-row-8" for="delivery-{productIdToEnsureUniqueSelectors}">
    <input
      type="radio"
      id="delivery-{productIdToEnsureUniqueSelectors}"
      class="fizz-radio-button"
      on:click|preventDefault={onDeliveryClick}
      checked={deliveryIsSelected}
    />
    <span>Delivery</span>
  </label>
</div>

{#if pickupIsSelected}
  <div
    class="fizz-stack-12 fizz-flex-row cursor-pointer fizz-justify-{justify}"
    data-testid="edit-pickup-location"
    on:click={onChangePickupLocation}
  >
    <span class="fizz-inline-12" data-testid="current-pickup-location">{pickupLocationName}</span>
    <Icon type="Edit" extraClassNames="fizz-icon-12" />
  </div>
{/if}
